<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateImage"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteImage"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['image'],
    data() {
      return {
        deleteConfirmVisible: false
      };
    },

    methods: {
      async deleteImage() {
        this.deleteConfirmVisible = false;
        this.$emit('delete', this.image);
      },
      updateImage() {
        this.$emit('update', this.image);
      }
    }
  };
</script>
